export default __webpack_public_path__ + "static/media/logo7.a548c0e3.jpg";